import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Breadcrumb from './Breadcrumb';
import BreadcrumbLD from '@/components/shared/BreadcrumbLD';
import usePageMeta from '@/hooks/usePageMeta';
import { getPageMeta } from '@/data/pageMeta';

const NO_BREADCRUMB = ['/', '/book-a-call'];

export default function PageLayout({ children }) {
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  const showBreadcrumb = !NO_BREADCRUMB.includes(pathname);

  // Apply per-route OG / Twitter / title metadata. Pages with dynamic
  // content (leadership bios, news articles, confirmation) override this
  // by calling usePageMeta themselves with richer data.
  usePageMeta(getPageMeta(pathname));

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--mcx-paper)' }}>
      {!isHome && <BreadcrumbLD />}
      <Header />
      <main id="main-content" className="flex-grow" tabIndex="-1">
        {!isHome && showBreadcrumb && <Breadcrumb />}
        {children}
      </main>
      <Footer />
    </div>
  );
}
